import { isEqual } from 'lodash';
import { bool, func, shape, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
  getTransformedOpportunity,
  transformForPatch,
  transformForRendering,
} from '../../opportunities/transform-opportunity-helpers';
import { opportunityShape } from '../../prop-types';
import api from '../../REST/api';
import update from '../../REST/update';
import { tapFlashSuccess } from '../../utils/flash';
import { removeUnchangedValues } from '../../utils/remove-unchanged-values';
import ProjectEntity from '../ProjectEntity';
import { ProjectEntityPropTypes } from '../ProjectEntity/ProjectEntity';

class ProjectOpportunityFormWrapper extends React.Component {
  state = {
    model: this.props.model,
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.model, this.props.model)) {
      this.updateModelWithLatestState();
    }
  }

  handleSave = e => {
    this.props.onSubmit(e).then(this.props.entityProps.onSave);
  };

  handleCancel = e => {
    this.props.onDiscard(e);
    this.props.entityProps.onCancel();
  };

  addCampaignIdToModel = campaign => {
    this.setState(prevState => ({
      model: {
        ...prevState.model,
        campaignId: campaign.id,
      },
    }));
  };

  // This is done so that the updated props onChange is updated in the state. Also it
  // maintains the campaignId state after it has been modified and another field changed
  // so that the campaignId does not obtain the previous state(before creation/recreation)
  updateModelWithLatestState() {
    const { campaignId } = this.state.model;
    this.setState(prevState => {
      const modifiedKeys = removeUnchangedValues(
        this.props.model,
        prevState.model,
      );
      return { model: { ...prevState.model, ...modifiedKeys, campaignId } };
    });
  }

  render() {
    const {
      onChange,
      entityProps,
      renderTitle,
      isExpandable,
      renderContent,
      campaignLinesById,
    } = this.props;
    const { isEditing } = entityProps;
    const { model } = this.state;
    return (
      <ProjectEntity
        title={renderTitle({
          model,
          addCampaignIdToModel: this.addCampaignIdToModel,
          isEditing,
          campaignLinesById,
        })}
        {...entityProps}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        isExpandable={isExpandable}
      >
        {renderContent(model, onChange, isEditing)}
      </ProjectEntity>
    );
  }
}

ProjectOpportunityFormWrapper.propTypes = {
  model: opportunityShape.isRequired,
  opportunityId: string.isRequired,
  onChange: func.isRequired,
  onSubmit: func.isRequired,
  onDiscard: func.isRequired,
  entityProps: shape(ProjectEntityPropTypes).isRequired,
  renderTitle: func.isRequired,
  isExpandable: bool,
  renderContent: func.isRequired,
  campaignLinesById: shape({}).isRequired,
};

ProjectOpportunityFormWrapper.defaultProps = {
  isExpandable: true,
};

const mapStateToProps = ({ campaignEditor }) => ({
  campaignLinesById: campaignEditor?.campaignLinesById,
});

export default connect(
  mapStateToProps,
  null,
)(
  update({
    query: getTransformedOpportunity,
    deriveQueryArgs: props => ({ id: props.opportunityId }),
    async update({ opportunityId }, changedModel, oldModel) {
      return api
        .patchOpportunity({
          id: opportunityId,
          data: await transformForPatch(changedModel, oldModel),
        })
        .then(transformForRendering)
        .then(tapFlashSuccess('Changes saved'));
    },
    form: ProjectOpportunityFormWrapper,
  }),
);
